<template>
    <div>
        <b-modal
            no-close-on-backdrop
            hide-header
            centered
            size="lg"
            hide-footer
            v-model="open"
        >
            <h4 class="text-center">Deseja deletar este parceiro?</h4>
            <div class="d-flex justify-content-around mt-5">
                <b-button variant="success" @click="partnerDelete()">Sim</b-button>
                <b-button variant="danger" @click="open = false">Não</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    emits: ['deletePartner'],
    data() {
        return {
            partnerId: "",
            open: false
        }
    },

    methods: {
        toggleOpen(partnerId) {
            this.open = !this.open;
            this.partnerId = partnerId;
        },

        partnerDelete() {
            this.$emit('deletePartner', this.partnerId);
            this.open = false;

        }
    }
}
</script>